<template>
  <div>
    <div
      class="testimonial__wrapper"
      @mousedown="handleMouseDown"
      @mousemove="handleMouseMove"
      @mouseup="handleMouseUp"
    >
      <div class="testimonial--button" @click="previousTestimonial">
        <img class="arrow left" src="@/assets/previous.png" alt="Edellinen" />
      </div>
      <div class="testimonial">
        <p class="review">"{{ currentTestimonial.review }}"</p>
        <p class="customer">
          <a
            target="_blank"
            v-if="currentTestimonial.href"
            :href="currentTestimonial.href"
            >{{ currentTestimonial.customer }}</a
          >
          <span v-else>{{ currentTestimonial.customer }}</span>
        </p>
      </div>
      <div class="testimonial--button" @click="nextTestimonial">
        <img class="arrow right" src="@/assets/next.png" alt="Seuraava" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      testimonials: [
        {
          review:
            "Tunnelma oli teidän ansioista vielä parempi kuin oltais edes osattu toivoa. Tää oli ihan mielettömän hieno juttu!",
          customer: "Selma & Hannes"
        },
        {
          review:
            "Amiraali Ahtio on loistava bilebändi! Häissämme bändin energinen esiintyminen ja hyvät soittolistat takasivat sen, että tunnelma pysyi huipussaan pitkälle yöhön asti.",
          customer: "Maria"
        },
        {
          review: "Wooow mikä bändi - ehkä rakastuin just",
          customer: "Sabina"
        },
        {
          review:
            "Älyttömän kova meininki! Kaikilta häävierailta tuli vain positiivista palautetta. Myös käytännön järjestelyjen osalta kaikki oli mutkatonta.",
          customer: "Santtu & Juulia"
        },
        {
          review:
            "Kerran vielä kiitos mahtavasta showsta, teitte juhlista upeat.",
          customer: "Matias & Mari"
        },
        {
          review:
            "Olitte ihan täydellinen bändi - iso kiitos vielä! Tulemma kyllä vinkkaamaan teistä kaikille 😉",
          customer: "Henniina & Sampo"
        },
        {
          review:
            "Ihan mielettömät kiitokset teille huikeesta setistä!!! Bändi oli monen mielestä illan paras juttu ja musiikki oli erinomaista, olette kyllä super taitavia kaikki.",
          customer: "Jannika"
        },
        {
          review:
            "Saatiin bändistä erittäin paljon kehuja vierailta ja olette ne kaikki ansainneet! Kiitos =)",
          customer: "Sami"
        },
        {
          review: "Kiitos vielä tuhannesti! Olitte loistavia!",
          customer: "Joni"
        },
        {
          review:
            "Heippa ja valtavan iso kiitos aivan älyttömän hyvästä keikasta! Saatiin myös vierailta runsaasti kehuja teistä, joidenkin kohdalla useampaankin otteeseen.",
          customer: "Tuuli ja Henri"
        },
        {
          review: "Kiitos teille! Ei olisi voinut toivoa parempaa!",
          customer: "Maija & Olli"
        },
        {
          review:
            "Aivan huikea tunnelman nostattaja on tämä bändi. Saa hetkessä tanssimaan kaikki juhlijat taaperosta vaariin. Suosittelemme lämpimästi!",
          customer: "Raija"
        },
        {
          review:
            "Kiitos erinomaisesta setistä ja bileistä. Porukka oli todella fiiliksissä ja kyselivät että mistä tällainen bändi on oikeen löytynyt!",
          customer: "Janne & Outi"
        },
        {
          review:
            "On suuri ilo tehdä yhteistyötä ammatitaitoisen ja superhauskan bändin kanssa! Jos haluat vauhtia tanssilattialla, tämä bändi on sinulle.",
          customer: "Juhlakirsikka",
          href: "https://juhlakirsikka.fi/"
        },
        {
          review: "Teitte hääjuhlistamme unohtumattomat!",
          customer: "Irina & Jesse"
        },
        {
          review:
            "Suurkiitokset, kun tulitte — teitte illan bileistä aivan huikeat!",
          customer: "Henna"
        }
      ],
      currentTestimonialIndex: 0,
      touchStartX: 0,
      touchEndX: 0,
      isDragging: false
    };
  },
  computed: {
    currentTestimonial() {
      return this.testimonials[this.currentTestimonialIndex];
    }
  },
  methods: {
    previousTestimonial() {
      this.resetTimer();
      if (this.currentTestimonialIndex > 0) {
        this.currentTestimonialIndex--;
      } else {
        this.currentTestimonialIndex = this.testimonials.length - 1;
      }
    },
    nextTestimonial() {
      this.resetTimer();
      if (this.currentTestimonialIndex < this.testimonials.length - 1) {
        this.currentTestimonialIndex++;
      } else {
        this.currentTestimonialIndex = 0;
      }
    },
    randomizeTestimonial() {
      this.resetTimer();
      const randomIndex = Math.floor(Math.random() * this.testimonials.length);
      this.currentTestimonialIndex = randomIndex;
    },
    startTimer() {
      this.timer = setInterval(this.nextTestimonial, 8000);
    },
    resetTimer() {
      clearInterval(this.timer);
      this.startTimer();
    },
    handleTouchStart(event) {
      this.touchStartX = event.changedTouches[0].clientX;
    },
    handleTouchEnd(event) {
      this.touchEndX = event.changedTouches[0].clientX;
      const deltaX = this.touchEndX - this.touchStartX;
      if (deltaX > 50) {
        this.previousTestimonial();
      } else if (deltaX < -50) {
        this.nextTestimonial();
      }
    },
    handleMouseDown(event) {
      this.isDragging = true;
      this.mouseStartX = event.clientX;
    },
    handleMouseMove(event) {
      if (!this.isDragging) return;
      const deltaX = event.clientX - this.mouseStartX;
      if (deltaX > 50) {
        this.previousTestimonial();
        this.isDragging = false;
      } else if (deltaX < -50) {
        this.nextTestimonial();
        this.isDragging = false;
      }
    },
    handleMouseUp() {
      this.isDragging = false;
    }
  },
  mounted() {
    this.startTimer(); // Aloita ajastin
    this.randomizeTestimonial(); // Näytä satunnainen testimonial aluksi
    // Lisää touch-tapahtumankäsittelijät
    this.$el.addEventListener("touchstart", this.handleTouchStart);
    this.$el.addEventListener("touchend", this.handleTouchEnd);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    // Poista touch-tapahtumankäsittelijät
    this.$el.removeEventListener("touchstart", this.handleTouchStart);
    this.$el.removeEventListener("touchend", this.handleTouchEnd);
  }
};
</script>

<style scoped>
.testimonial__wrapper {
  display: flex;
  align-items: center;
  margin: auto;
  justify-content: center;
  min-height: 160px;
}

.testimonial--button {
  cursor: pointer;
}

.testimonial {
  text-align: center;
  width: 100%;
  padding: 0 1rem;
}
.review {
  font-style: italic;
}
.customer {
  font-weight: bold;
}
.arrow {
  max-width: 48px;
}

@media (max-width: 900px) {
  .testimonial__wrapper {
    min-height: 260px;
    padding: 0;
  }
  .testimonial {
    padding: 0;
  }

  .left {
    margin-left: -2rem;
  }
  .right {
    margin-right: -2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Testimonials.vue